/**
 * Shared behavior for every snippets/newsletter-form.liquid instance on the
 * page (homepage newsletter section, footer, etc.):
 *
 * - Field name switching: the one visible field always posts as
 *   `contact[email]` by default; if the value looks like a 10-digit mobile
 *   number instead, the field is renamed to `contact[phone]` just before
 *   submit so Shopify stores it against the right customer field.
 * - Sending state: since {% form 'customer' %} is a real (non-Ajax) POST,
 *   this only shows for the moment before the page navigates away, but it
 *   still gives immediate feedback instead of the button looking inert.
 * - "Already subscribed": Shopify's customer form reports success even on
 *   a second signup with the same address - there's no native distinct
 *   signal. This is approximated with a `vellum:newsletterSubscribed`
 *   localStorage flag: if a success message renders and the flag was
 *   already set from a previous successful submit in this browser, both
 *   the copy AND the icon swap to the "already on the list" variant
 *   (check -> info) so the state isn't signalled by text alone. The
 *   replacement icon is pre-rendered server-side into a <template> right
 *   after the message (snippets/icon.liquid stays the one source of truth
 *   for every glyph - nothing here hand-builds SVG markup).
 */
function isPhoneNumber(value) {
  return /^\d{10}$/.test(value.replace(/\D/g, ''));
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.newsletter-form');
  if (!form) return;

  const input = form.querySelector('[data-newsletter-input]');
  const submitButton = form.querySelector('[data-newsletter-submit]');

  if (input) {
    const raw = input.value.trim();
    if (isPhoneNumber(raw)) {
      input.name = 'contact[phone]';
      input.value = raw.replace(/\D/g, '');
    } else {
      input.name = 'contact[email]';
    }
  }

  if (submitButton) {
    submitButton.setAttribute('data-loading', '');
    submitButton.disabled = true;
  }
});

function markAlreadySubscribedIfNeeded() {
  const key = 'vellum:newsletterSubscribed';
  document.querySelectorAll('[data-newsletter-success]').forEach((message) => {
    if (window.localStorage.getItem(key)) {
      const textEl = message.querySelector('[data-newsletter-success-text]');
      if (textEl) textEl.textContent = message.dataset.alreadySubscribedText || textEl.textContent;

      const iconEl = message.querySelector('[data-newsletter-success-icon]');
      const iconTemplate = message.nextElementSibling;
      if (iconEl && iconTemplate && iconTemplate.matches('[data-newsletter-already-subscribed-icon]')) {
        iconEl.replaceChildren(iconTemplate.content.cloneNode(true));
      }
    } else {
      window.localStorage.setItem(key, '1');
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', markAlreadySubscribedIfNeeded);
} else {
  markAlreadySubscribedIfNeeded();
}
